import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export const useSentrySetDashBoardTag = ({
  dashboardName
}: {
  dashboardName: string;
}) => {
  useEffect(() => {
    Sentry.setTag('dashboard_name', dashboardName);
  }, [dashboardName]);
};
